import { useEffect, useRef, useState } from "react";

function useInView(ref) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setVisible(true);
      },
      { threshold: 0.1 },
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref]);
  return visible;
}

function AnimCard({ className, children, delay = 0 }) {
  const ref = useRef(null);
  const visible = useInView(ref);
  return (
    <div
      ref={ref}
      className={`${className} ${visible ? "visible" : ""}`}
      style={visible ? { transitionDelay: `${delay}ms` } : {}}
    >
      {children}
    </div>
  );
}

function About() {
  return (
    <section className="si-section si-about" id="about">
      <div className="si-section-label">Who we are</div>
      <h2 className="si-h2">
        About <span style={{ color: "var(--accent)" }}>SwiftIntelli</span>
      </h2>

      <div className="si-about-grid">
        <div>
          <p
            style={{
              color: "var(--text-muted)",
              fontSize: 16,
              lineHeight: 1.8,
              marginBottom: 24,
            }}
          >
            SwiftIntelli is a software training platform helping students build
            practical software and technology skills through real world learning
            and industry focused training.{" "}
          </p>
          <p
            style={{
              color: "var(--text-muted)",
              fontSize: 16,
              lineHeight: 1.8,
              marginBottom: 24,
            }}
          >
            We combine expert mentorship, hands-on projects, and career focused
            learning to help students gain job ready skills and grow confidently
            in today's digital world.
          </p>
          <p
            style={{
              color: "var(--text-muted)",
              fontSize: 16,
              lineHeight: 1.8,
            }}
          >
            From beginners to aspiring tech professionals, our programs are
            designed to support skill development, practical learning, and long
            term career growth.
          </p>
          <div className="si-about-features">
            {[
              {
                icon: "🧑‍🏫",
                title: "Industry Experts",
                text: "Instructors with real-world deployment experience",
              },
              {
                icon: "🛠️",
                title: "Hands-On Projects",
                text: "Build a portfolio from day one",
              },
              {
                icon: "🎓",
                title: "Certified Programs",
                text: "Industry-recognized certifications",
              },
              {
                icon: "🌙",
                title: "Flexible Timing",
                text: "Weekend & IST-compatible batches",
              },
            ].map((f, i) => (
              <AnimCard key={i} className="si-feature-chip" delay={i * 80}>
                <div className="si-chip-icon">{f.icon}</div>
                <div className="si-chip-title">{f.title}</div>
                <div className="si-chip-text">{f.text}</div>
              </AnimCard>
            ))}
          </div>
        </div>
        <div>
          <div className="si-about-card">
            <div className="si-mission-text">
              <h2>
                We do more than teach technology. We help build the{" "}
                <em>next generation</em> of skilled and confident tech
                professionals.
              </h2>
            </div>
            <p
              style={{
                color: "var(--text-muted)",
                fontSize: 14,
                lineHeight: 1.7,
              }}
            >
              Our training programs are designed to help students and aspiring
              developers gain practical software skills through real world
              projects, hands-on learning, and industry focused training.
              Whether you are starting your tech journey or improving your
              existing skills, we provide the right learning path to support
              your career growth.
            </p>
            <div className="si-mini-stats">
              {[
                ["12+", "c1", "Expert Instructors"],
                ["4.9★", "c2", "Average Rating"],
                ["Live", "c1", "Project Mentoring"],
                ["24/7", "c2", "Learning Access"],
              ].map(([v, c, l]) => (
                <div key={l}>
                  <div className={`si-mini-stat-num ${c}`}>{v}</div>
                  <div className="si-mini-stat-label">{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
